import { Root } from '@amcharts/amcharts5';
import { AxisRenderer, CategoryAxis, DateAxis, XYChart } from '@amcharts/amcharts5/xy';
import React from 'react';

import { createBullets } from 'features/Events/components/EventsChart/utils/createBullets';
import { EventData } from 'features/Events/types/eventData';
import { lineSeries } from 'utils/charts/charts';
import { lineSeriesSettings } from 'utils/charts/settings';

export const setSeries = (
  root: Root,
  chart: XYChart,
  yAxis: CategoryAxis<AxisRenderer>,
  xAxis: DateAxis<AxisRenderer>,
  chartData: EventData[],
  lineColor: string,
  setShowModal: (show: boolean) => void,
  setModalContent: (modal: React.ReactElement) => void
) => {
  const series = chart.series.push(lineSeries(root, lineSeriesSettings(xAxis, yAxis, lineColor)));
  createBullets(series, setShowModal, setModalContent);
  series.data.setAll(chartData);
  series.appear();
};
